import { Avatar, Button, Dropdown, Flex, MenuProps, Skeleton, Space, Typography } from 'antd';
import { FC, memo } from 'react';

import { AppMessage } from '@/common/components';
import { useAuthState } from '@/common/hooks';
import { messageOnError } from '@/common/utils';

import { useLogoutAuthMutation } from '@/modules/Auth';
import { UserPosition } from '@/modules/Users';

export const UserPanelSectionView: FC = memo(() => {
  const { sessionUser, isAuthed, setAuthingState, setSessionUser } = useAuthState();
  const appMessageApi = AppMessage.useControls();

  const { isLoading: isLogoutLoading, mutateAsync: logoutMutation } = useLogoutAuthMutation()({
    onSuccess: () => {
      setSessionUser(null);
      setAuthingState(false);
      window.location.reload();
    },
    onError: (error) => {
      messageOnError(error, appMessageApi);
    },
  });

  const menu: MenuProps = {
    items: [
      {
        key: 'profile',
        disabled: true,
        label: 'Профіль',
      },
      {
        key: 'divider',
        type: 'divider',
      },
      {
        key: 'logout',
        disabled: isLogoutLoading,
        onClick: async () => await logoutMutation(),
        danger: true,
        label: 'Вийти',
      },
    ],
  };

  if (isAuthed && sessionUser) {
    return (
      <div>
        <Dropdown menu={menu} trigger={['click']}>
          <Button
            style={{ height: 30, paddingBlock: 0, paddingInline: 4 }}
            type="text"
            loading={isLogoutLoading}
            disabled={isLogoutLoading}
          >
            <Flex align="center">
              <Avatar style={{ height: 26, width: 26 }} shape="square" src={sessionUser.avatar} />
              &nbsp;
              <Flex align="flex-start" vertical justify="space-evenly" style={{ fontSize: 12, lineHeight: 1, height: 30 }}>
                <span>{sessionUser.fullName}</span>
                <Typography.Text type="secondary" style={{ lineHeight: 1.2, fontSize: 10 }}>
                  <span>{sessionUser.position}</span>
                  &nbsp;
                  {sessionUser.position === UserPosition.Administrator && '★'}
                </Typography.Text>
              </Flex>
            </Flex>
          </Button>
        </Dropdown>
      </div>
    );
  }

  return (
    <div>
      <Space size="small">
        <Skeleton.Avatar size="default" />
        <Skeleton.Input size="default" />
      </Space>
    </div>
  );
});
